import type {
  AccessType,
  AccessTypeWoLeaderObtain,
} from '~packages/epk-front-module-access';

import type { IModel } from '../../shared/types';

export const typeCodeMap: Record<AccessTypeWoLeaderObtain, number> = {
  'role-change': 1,
  'oktmo-obtain': 2,
  'oktmo-return': 3,
  'leader-change': 4,
  'epk-delete': 5,
};

export const codeTypeMap = {} as Record<string, AccessTypeWoLeaderObtain>;

for (const k in typeCodeMap) {
  const code = String(typeCodeMap[k as AccessTypeWoLeaderObtain]);
  codeTypeMap[code] = k as AccessTypeWoLeaderObtain;
}

export const dtoFactory = (type: AccessType, modelVal: IModel) => {
  let dto;

  switch (type) {
    case 'leader-change':
      dto = dtoFactoryLeaderChange(modelVal);
      break;
    case 'leader-obtain':
      dto = dtoFactoryLeaderChange(modelVal);
      break;
    case 'role-change':
      dto = dtoFactoryRoleChange(modelVal);
      break;
    case 'oktmo-obtain':
      dto = dtoFactoryOktmoObtain(modelVal);
      break;
    case 'oktmo-return':
      dto = dtoFactoryOktmoReturn(modelVal);
      break;
    case 'epk-delete':
      dto = dtoFactoryEpkDelete(modelVal);
      break;
    default:
      return;
  }

  return dto;
};

const dtoFactoryBase = (modelVal: IModel) => {
  if (modelVal.executorOrgList)
    return {
      applicant_comment: modelVal.comment,
      applicant_phone: modelVal.add_phone,
      req_oktmo_executor: modelVal.executorOrgList[0].code.toString(),
    } as {
      applicant_comment: string;
      applicant_phone: string;
      [k: string]: unknown;
    };
  else
    return {
      applicant_comment: modelVal.comment,
      applicant_phone: modelVal.add_phone,
    } as {
      applicant_comment: string;
      applicant_phone: string;
      [k: string]: unknown;
    };
};

export const dtoFactoryLeaderChange = (modelVal: IModel) => {
  const dto = dtoFactoryBase(modelVal);

  dto.type_req = typeCodeMap['leader-change'];

  return dto;
};

export const dtoFactoryOktmoObtain = (modelVal: IModel) => {
  const dto = dtoFactoryBase(modelVal);

  interface IRow {
    user: string;
    oktmo: number;
    type_right_read_only: boolean;
    type_right_read_write: boolean;
  }

  dto.type_req = typeCodeMap['oktmo-obtain'];

  /*  */
  const arr = [] as IRow[];

  modelVal.employeeList.forEach(e => {
    const employeeOktmoSet = new Set();

    ['accesses', '_accesses'].forEach(k => {
      const v = e[k];
      if (!Array.isArray(v)) return;

      v.forEach(a => {
        const oktmo = Number(a.oktmo);

        if (employeeOktmoSet.has(oktmo)) return;
        employeeOktmoSet.add(oktmo);

        arr.push({
          user: e.user.user,
          oktmo: oktmo,
          type_right_read_only: a.type_right_read_only,
          type_right_read_write: a.type_right_read_write,
        });
      });
    });
  });

  dto.matrix_right = arr;

  return dto;
};

export const dtoFactoryOktmoReturn = (modelVal: IModel) => {
  const dto = dtoFactoryBase(modelVal);

  dto.type_req = typeCodeMap['oktmo-return'];
  const arr = modelVal.oktmos.map(i => Number(i));
  dto.oktmos = arr;

  return dto;
};

export const dtoFactoryRoleChange = (modelVal: IModel) => {
  const dto = dtoFactoryBase(modelVal);

  dto.type_req = typeCodeMap['role-change'];
  dto.type_role = modelVal.role;

  return dto;
};
export const dtoFactoryEpkDelete = (modelVal: IModel) => {
  const dto = dtoFactoryBase(modelVal);

  dto.type_req = typeCodeMap['epk-delete'];
  // TODO
  dto.entity = {
    // entity_type - Объект/словарь с данными о сущности. 1 - Похозяйственная книга
    entity_type: 1,
    // entity_code - Код сущности. Номер книги, номер ЛС и т.д.
    entity_code: String(modelVal.entity_code),
  };

  return dto;
};
